export function DashboardWorkingMechanicsCtrl (
  $scope,
  $state,
  $translate,
  messages,
  workshopAPI
) {

  $scope.tableSettings = {
    broadcast: 'filterQuotes',
    columns  : [
      {
        field : 'display_name',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.NAME')}
      },
      {
        field : 'begin_time',
        header: {
          text: $translate.instant('BOOKING_SPACE.START_TIME')
        },
        pipe    : 'globalDate',
        pipeArgs: 'MMM d, yyyy h:mm a'
      },
      {
        field : 'description',
        header: {
          text: $translate.instant('BOOKING_SPACE.JOB')
        }
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_JOBS_IN_PROGRESS')
    },
    pagination: {
      enabled   : true,
      pageSize  : 5,
      pageSizes : [ 5, 10 ],
      queryCount: () => workshopAPI.get('/dashboard/jobs_in_progress_count').then(data => data[0].count)
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
  };

  $scope.onRowDoubleClick = function (event) {
    $state.go('app.invoice', {
      customer_id: event.row.job_customer_id || event.row.customer_id,
      vehicle_id : event.row.job_vehicle_id || event.row.vehicle_id,
      id         : event.row.job_id || event.row.invoice_id
    });
  };

  $scope.getMechanics = ( params ) => {
    return workshopAPI.get('/dashboard/mechanics_clocked_in', [
      params.pageSize,
      params.offset
    ]).then(mechanics => {
      $scope.mechanics = mechanics;

      return mechanics;
    });
  };

  $scope.refresh = function () {
    $state.reload();

    messages.show($translate.instant('JS_SPACE.MESSAGES.REFRESHED'), 'success');
  };
}
